import { BacksolveSourceRow } from 'api/models/BacksolveSourceRow';
import { SOURCE_ROW_ZX_INDEX_RECORD_ID } from './sheetAliases';

const normalizeSourceRowsOrder = (rows: BacksolveSourceRow[]): BacksolveSourceRow[] => {
  const zxRows = rows.filter(row => row.source_record_id === SOURCE_ROW_ZX_INDEX_RECORD_ID);
  const otherRows = rows
    .filter(row => row.source_record_id !== SOURCE_ROW_ZX_INDEX_RECORD_ID)
    .sort((a, b) => {
      if (!a.date) {
        return 1;
      }
      if (!b.date) {
        return -1;
      }
      if (a.date !== b.date) {
        return b.date.localeCompare(a.date);
      }
      return (b.source_record_id ?? '').localeCompare(a.source_record_id ?? '');
    });

  return [...zxRows, ...otherRows].map((row, index) => ({
    ...row,
    order: index,
  }));
};

export default normalizeSourceRowsOrder;
